/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { INSPECTOR_NODE_TYPE, TInspectorNode } from "../InspectorNodeTypes";
import { ISchemaStringTranslateModel, isSchemaStringTranslateModel } from "@adapptio/lib-blueprint";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";

export function stringTranslateMapper(model: ISchemaStringTranslateModel): TInspectorNode {
	if (!isSchemaStringTranslateModel(model)) {
		return;
	}

	// @TODO: finish

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: model.schema.opts.label,
		tooltip: model.schema.opts.description,
		descriptor: mapperDescriptor(model.schema),
		examples: mapperExamples(model.schema),
		deps: [ model ],
		controls: [],
		children: []
	};
}
